// IHTP Methodology — 5 phases with their fields
export const PHASES = [
    {
        num: 1,
        key: "diagnostico",
        title: "Avaliar Diagnóstico",
        verb: "Escutar",
        summary:
            "Compreender o estado atual da organização e identificar a base para a felicidade e o sucesso do projeto.",
        concepts: ["Visão, Missão e Valores", "Diagnóstico", "Satisfação", "Forças e Fraquezas", "Congruência", "Escutar"],
        fields: [
            { key: "historia", label: "História da Organização", type: "textarea", hint: "Eventos, decisões e impacto ao longo do tempo." },
            { key: "visao_missao_valores", label: "Visão, Missão e Valores", type: "textarea" },
            { key: "procedimentos", label: "Procedimentos", type: "textarea", hint: "Processos e fluxos de trabalho atuais." },
            { key: "nivel_satisfacao", label: "Nível de Satisfação", type: "scale" },
            { key: "forcas", label: "Forças", type: "textarea" },
            { key: "fraquezas", label: "Fraquezas", type: "textarea" },
            { key: "congruencia", label: "Níveis de Congruência", type: "textarea", hint: "Alinhamento entre valores declarados e práticas reais." },
            { key: "sugestoes", label: "Sugestões de Melhoria", type: "textarea" },
        ],
    },
    {
        num: 2,
        key: "projetar_futuro",
        title: "Projetar Futuro",
        verb: "Priorizar",
        summary: "Visionar e definir o estado futuro desejado com base no diagnóstico.",
        concepts: ["Visão", "Metas", "Indicadores", "Sistemas de Avaliação", "Priorizar"],
        fields: [
            { key: "visao_global", label: "Visão Global", type: "textarea" },
            { key: "metas", label: "Metas a Alcançar", type: "textarea" },
            { key: "indicadores", label: "Indicadores", type: "textarea" },
            { key: "sistemas_avaliacao", label: "Sistemas de Avaliação", type: "textarea" },
            { key: "caminhos", label: "Caminhos Possíveis", type: "textarea" },
            { key: "prazos_avaliacao", label: "Prazos de Avaliação", type: "text" },
        ],
    },
    {
        num: 3,
        key: "planear",
        title: "Planear",
        verb: "Envolver",
        summary: "Desenvolver planos detalhados e estratégias para unir o estado atual ao futuro.",
        concepts: ["Envolver", "Planear", "Habilidades", "Comportamentos", "Recursos", "Alinhamento"],
        fields: [
            { key: "planos_detalhados", label: "Planos Detalhados", type: "textarea" },
            { key: "habilidades", label: "Habilidades a Desenvolver", type: "textarea" },
            { key: "acoes_comportamentos", label: "Ações para Mudar Comportamentos", type: "textarea" },
            { key: "recursos", label: "Recursos por Atividade", type: "textarea", hint: "Pessoas, competências, orçamento..." },
            { key: "utilidade_alinhamento", label: "Utilidade e Alinhamento com as Metas", type: "textarea" },
        ],
    },
    {
        num: 4,
        key: "implementar",
        title: "Implementar",
        verb: "Agir",
        summary: "Executar os planos e trazer a visão para a realidade, combinando razão e coração.",
        concepts: ["Agir", "Acompanhar", "Razão e Coração", "Disciplinar", "Suporte", "Paciência", "Resiliência"],
        fields: [
            { key: "execucao", label: "Execução", type: "textarea" },
            { key: "resultados", label: "Resultados", type: "textarea" },
            { key: "sugestoes", label: "Sugestões de Melhoria", type: "textarea" },
            { key: "constrangimentos", label: "Constrangimentos", type: "textarea" },
            { key: "desvios", label: "Desvios ao Plano", type: "textarea" },
            { key: "solucoes_futuras", label: "Soluções a Implementar no Futuro", type: "textarea" },
        ],
    },
    {
        num: 5,
        key: "avaliar",
        title: "Avaliar",
        verb: "Ser Resiliente",
        summary: "Avaliar resultados globais, retirar lições e preparar ciclos futuros.",
        concepts: ["Verificar Execução", "Avaliar Resultados", "Ajustar", "Comemorar Vitórias", "Apoiar nos Fracassos", "Ser Resiliente"],
        fields: [
            { key: "execucao_final", label: "Verificar Execução", type: "textarea" },
            { key: "avaliacao_resultados", label: "Avaliação dos Resultados", type: "textarea" },
            { key: "sugestoes_finais", label: "Sugestões de Melhoria", type: "textarea" },
            { key: "constrangimentos_finais", label: "Constrangimentos", type: "textarea" },
            { key: "ajuste_plano", label: "Ajustes ao Plano", type: "textarea" },
            { key: "vitorias", label: "Vitórias a Celebrar", type: "textarea" },
            { key: "fracassos", label: "Fracassos - Lições Aprendidas", type: "textarea" },
        ],
    },
];

export const ROLE_LABELS = {
    super_admin: "Super Admin",
    company_manager: "Gestor de Empresa",
    happiness_manager: "Happiness Manager",
    project_manager: "Gestor de Projeto",
    collaborator: "Colaborador",
};

export const ROLE_DESCRIPTIONS = {
    company_manager: "Acesso total à empresa: dados, faturação, projetos, utilizadores, metodologia",
    happiness_manager: "Acesso a todos os projetos da empresa, metodologia, estatísticas e inquéritos",
    project_manager: "Acesso apenas aos projetos onde for atribuído como gestor",
    collaborator: "Participa nos projetos e responde a inquéritos das fases ativas",
};
